<template>
  <section class="blog-section">
    <div class="container oversized-container">
      <div class="row">
        <div class="col-12 col-title-s1">
          <h3 class="title">Comunicados</h3>
        </div>

        <div class="col-12 col-articles">
          <swiper class="swiper" :options="blogOptions">
            <swiper-slide v-for="comDo in catalogosGetComunicados" :key="comDo.id">
              <div class="col-12 col-article-sample-1">
                <router-link class="box-article" :to="'/comunicados/' + comDo.id">
				
                  <div 	class="placed-backg box-image">
                    <api-img :comp="comDo.imagenes_id" size="512/512"/>
                  </div>

                  <div class="box-descr">
                    <h5>{{comDo.titulo}}</h5>

                    <div class="descr">{{comDo.extracto}}</div>
                  </div>
                </router-link>
              </div>
            </swiper-slide>

            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  	props: {
		blogOptions: {
			type: Object,
			default: () => {
				return {
					slidesPerView: 5,
					spaceBetween: 0,

					pagination: {
						el: ".swiper-pagination",
						clickable: true,
					},

					breakpoints: {
						1470: {
							slidesPerView: 5,
						},
						1200: {
							slidesPerView: 4,
						},
						992: {
							slidesPerView: 3,

							pagination: {
								el: ".swiper-pagination",
								dynamicBullets: false
							},
						},
						576: {
							slidesPerView: 2,
						},
						1: {
							slidesPerView: 1,

							pagination: {
								el: ".swiper-pagination",
								dynamicBullets: true,
							},
						},
					},
				};
			}
		}
  	},
	computed: {
		...mapGetters(['catalogosGetComunicados'])
	}
};
</script>

<style>
</style>